import { render, staticRenderFns } from "./StatusParam.vue?vue&type=template&id=2010653c&scoped=true&"
import script from "./StatusParam.vue?vue&type=script&lang=ts&"
export * from "./StatusParam.vue?vue&type=script&lang=ts&"
import style0 from "./StatusParam.vue?vue&type=style&index=0&id=2010653c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2010653c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VDataTable,VTextField})
